import api from './api';

export const getEvents = (params) => api.get('/calendar', { params });

export const getCalendarEvents = (spaceId, start, end) =>
  api.get('/calendar', { params: { spaceId, start, end } });

export const createEvent = (data) => api.post('/calendar', data);

export const updateEvent = (eventId, data) => api.patch(`/calendar/${eventId}`, data);

export const deleteEvent = (eventId) => api.delete(`/calendar/${eventId}`);
